import { createApp } from "vue";
import Antd, { Card, Table } from "ant-design-vue";
import "@/style.css";
import App from "@/App.vue";
import { router, initialize as routerInitialize } from "@/route";
import routerGuardInitialize from "@/route/guard";
import { createPinia } from "pinia";
import "ant-design-vue/dist/reset.css";
import { permissionDirective } from "@/directives/permission";

/**
 * @typedef {import('vue').ComponentCustomProperties} ComponentCustomProperties
 *
 * @type {import('vue').App} app
 */
const initApp = async () => {
  // 创建app
  console.info("初始化app");
  const app = createApp(App);

  // 创建pinia
  console.info("创建pinia");
  const pinia = createPinia();
  app.use(pinia);

  console.info("创建router");
  await routerInitialize(app);

  // 创建路由守护
  console.info("创建路由守护");
  routerGuardInitialize();

  console.info("创建Antd");
  app.use(Antd);

  await router.isReady();
  console.info("router准备完成");

  // 定义全局方法 $imageUrl
  app.config.globalProperties.$imageUrl = (path) => {
    if (!path) {
      return "";
    }
    const baseUrl = import.meta.env.VITE_IMAGE_BASE_URL;
    // 如果 path 是 http/https 开头，直接返回
    if (/^https?:\/\//i.test(path)) {
      return path;
    }
    // 处理路径格式（避免双斜杠）
    return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  };

  app.config.globalProperties.$uploadUrl = import.meta.env.VITE_UPLOAD_BASE_URL;

  app.directive("has", permissionDirective);

  console.info("挂载app");
  app.mount("#app", true);
};

Card.props.size.default = "small";
Table.props.size.default = "middle";
initApp();
